import axios from 'axios'
import library from '../../../utils/Library'

export const updateAppVersionRTEnviroments = async (
  appCode,
  appPlatformCode,
  appVersionCode
) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = `${library.getBaseAPIUrl(
    'version_enviroments'
  )}/updateAppVersionRTEnviroments`

  return await axios({
    url: URL,
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: {
      appCode,
      appPlatformCode,
      appVersionCode,
      deprecationDate: new Date().toISOString()
    }
  })
}
